import clsx from 'clsx';
import React from 'react';
import { InView } from 'react-intersection-observer';

import LazyImgixImage from '@components/LazyImgixImage';
import useEventTracking from '@hooks/useEventTracking';
import {
  ClickTarget,
  ImpressionElement,
  Page,
  TrackingLocation,
  click,
  impression,
} from '@tracking';

import { TITVPartnerAd } from './interfaces';

const Partners = ({
  partnerAds,
  hasBorder = false,
}: {
  partnerAds: TITVPartnerAd[];
  hasBorder?: boolean;
}) => {
  const { trackEvent } = useEventTracking({
    page: Page.TITV,
    location: TrackingLocation.TITVAdPartner,
  });

  return (
    <InView
      triggerOnce={true}
      onChange={(inView) => {
        inView &&
          trackEvent(impression({ impressionElement: ImpressionElement.FeaturedPartnerAd }));
      }}
    >
      <section
        className={clsx('my-40 w-full', {
          'mt-40 border-0 border-t border-solid border-grayscale-charcoal': hasBorder,
          'sm:my-0': !hasBorder,
        })}
        data-testid="titv-partner-logo"
      >
        <h3 className="mb-40 mt-12 font-suisse-intl-mono text-overline-lg font-normal">
          Sponsored by
        </h3>
        <div className="flex flex-wrap items-start justify-center gap-32 sm:flex-row sm:items-end sm:justify-start">
          {partnerAds.map((partnerAd) => (
            <a
              key={partnerAd.name}
              className="min-w-min dark:bg-white dark:p-4"
              href={partnerAd.trackingLink}
              onClickCapture={() =>
                trackEvent(
                  click({
                    clickTarget: ClickTarget.Logo,
                    clickText: partnerAd.name,
                  })
                )
              }
              rel="noreferrer sponsored"
              target="_blank"
              data-testid={`titv-partner-logo-${partnerAd.name}`}
            >
              <LazyImgixImage
                src={partnerAd.logo}
                alt={`${partnerAd.name} logo`}
                className="max-h-[34px] w-auto max-w-[134px]"
                wrapperClassName="w-full"
              />
            </a>
          ))}
        </div>
      </section>
    </InView>
  );
};

export default Partners;
